import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { MainCardRoutingModal } from 'components/common/MainCardRoutingModal/mainCardRoutingModal';
import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { VersionSection } from 'components/common/PageContainer/versionSection';
import { VersionWrapper } from 'components/common/PageContainer/versionWrapper';
import { PageWidgetWrapper } from 'components/common/PageWidgetWrapper/PageWidgetWrapper';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';
import { ShareInsightButton } from 'components/common/ShareInsightButton/ShareInsightButton';

import { riskConfig } from 'components/Dashboards/ExcellenceApps/riskConfig';
import { TreeProgramTopHeader } from 'components/common';
import { CompareTo } from 'components/pages/DurationForecastPage/components/CompareTo/CompareTo';
import { DurationForecastFilter } from 'components/pages/DurationForecastPage/components/DurationForecastFilter/DurationForecastFilter';
import { GraphComponents } from 'components/pages/DurationForecastPage/components/GraphComponents/GraphComponents';
import { NlpThresholds } from 'components/pages/DurationForecastPage/components/NlpThresholds/NlpThresholds';

export const DurationForecastPage = () => {
    useFullStoryPageView({ pageName: riskConfig.durationForecast.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <VersionWrapper>
                    <VersionSection>
                        <TreeProgramTopHeader>
                            <CompareTo />
                            <ShareInsightButton title={riskConfig.durationForecast.title} link={window.location.href} />
                            <NlpThresholds />
                        </TreeProgramTopHeader>
                    </VersionSection>
                </VersionWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={riskConfig.durationForecast.title} />
                    <DurationForecastFilter />
                </BottomHeaderSection>
            </HeaderWrapper>

            <MainContent>
                <PageWidgetWrapper>
                    <GraphComponents />
                </PageWidgetWrapper>
            </MainContent>

            <MainCardRoutingModal queryKeys={['clustersData', 'clustersDataBySearchWord']} />
        </PageContainer>
    );
};
